import z from "zod";
import { guardString } from "../../strings";

export const getCoordinatesByAddressQuerySchema = z
	.object({
		address: z.string(),
	})
	.superRefine((values, context) => {
		if (values.address === guardString(null)) {
			context.addIssue({
				code: "custom",
				message: "Invalid Address",
				path: ["address"],
			});
		}
	});
